import Api, { make, Response } from 'src/services/api'

import { AddressCity, Id } from 'src/types'

type Data = {
  cities: AddressCity[]
}

type GetAllProps = {
  state: Id
  page?: number
  queryName: string
}

export const PAGE_SIZE = 10

async function getAll({
  state,
  page,
  queryName
}: GetAllProps): Promise<Response<AddressCity[]>> {
  return make<Data, AddressCity[]>({
    axiosCall: Api.get(
      `cities?page_size=${PAGE_SIZE}&page=${
        page || 1
      }&city=${queryName}&state=${state}`
    ),
    transformData: data => data.cities
  })
}

export default { getAll }
